import { TABLE_COLUMN_WIDTH } from "components/ModelCompare/constants";

import type { Section } from "../types";
import { u6enterprise } from "./products/u6enterprise";
import { u6lr } from "./products/u6lr";
import { u6plus } from "./products/u6plus";
import { u6pro } from "./products/u6pro";
import { u7lite } from "./products/u7Lite";
import { u7lr } from "./products/u7lr";
import { u7pro } from "./products/u7pro";
import { u7proMax } from "./products/u7proMax";
import { u7proXg } from "./products/u7proXg";
import { u7proXgs } from "./products/u7proXgs";
import {
  connectedDevices,
  dedicatedSpectral,
  dimensions,
  powerMethodPoe,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "./properties";

export const WifiFlagship: Section = {
  properties: [
    dimensions,
    wifiTechnology,
    dedicatedSpectral,
    radio6Ghz,
    wifiCoverage,
    connectedDevices,
    powerMethodPoe,
    uplink,
    wifiMounting,
  ],
  products: [
    u7proXgs,
    u7proXg,
    u7proMax,
    u7pro,
    u7lr,
    u7lite,
    u6enterprise,
    u6pro,
    u6lr,
    u6plus,
  ],
  columnWidth: TABLE_COLUMN_WIDTH,
  showBadges: true,
};
